"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _setPropTypes = _interopRequireDefault(require("recompose/setPropTypes"));

var _withHandlers = _interopRequireDefault(require("recompose/withHandlers"));

var _mapProps = _interopRequireDefault(require("recompose/mapProps"));

var withFormTracking = (0, _compose["default"])((0, _setPropTypes["default"])({
  failureLabel: _propTypes["default"].string,
  successLabel: _propTypes["default"].string.isRequired
}), (0, _withHandlers["default"])({
  handleSubmit: function handleSubmit(props) {
    return function (evt) {
      evt.stopPropagation();
      evt.preventDefault();
      return Promise.resolve(props.onSubmit(evt)).then(function // payload
      () {// Handle Redux-Form Submission Errors that resolve with an error
        // TODO: Implement FORM SUBMIT EVENT
      });
    };
  }
}), (0, _mapProps["default"])(function (props) {
  return (0, _extends2["default"])({}, (0, _omit["default"])(props, ['handleSubmit', 'invalid', 'successLabel', 'failureLabel']), {
    onSubmit: props.handleSubmit
  });
}));
var _default = withFormTracking;
exports["default"] = _default;